/**
 * Delays a fast-changing value so it can key a server query without firing one per keystroke.
 *
 * Extracted from `features/mail/MailPage.tsx`, which had the only copy, when the supplier picker
 * needed the same thing — a second copy of eight lines is how two search boxes end up debouncing
 * at different intervals for no reason anyone can later explain.
 */

import { useEffect, useState } from 'react'

export function useDebounced<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value)
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, delayMs])
  return settled
}

/** What a search-as-you-type box against a live server should wait. Long enough that a typed word
 * is one request rather than five, short enough that the list still feels immediate. */
export const SEARCH_DEBOUNCE_MS = 250
